import { NgModule, Component, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Network } from '../enums/gateway.enum';

@Pipe({
  name: "networkPipe"
})
export class NetworkPipe implements PipeTransform {
  translation: any;

  constructor(private translate: TranslateService) {
    this.translate.get('Gateway').subscribe(
      data => {
        this.translation = data;
      }
    )
  }

  transform(value: any): string {
    let text;
    switch (value) {
      case Network.network4G:
        text = this.translation.network4G;
        break;
      case Network.network5G:
        text = this.translation.network5G;
        break;
      case Network.networkWired:
        text = this.translation.networkWired;
        break;
    case Network.networkWireless:
        text = this.translation.networkWireless;
        break;
    case Network.networkOther:
        text = this.translation.networkOther;
        break;
    }
    return text;
  }
}
